/* @flow */
import { createSelector } from 'reselect';
import { getterFromKeyPath, alphabetizeByKey } from 'trustar/utils';
import { fromJS, Map, type OrderedMap } from 'immutable';
import { tryCatch, pipe } from 'ramda';

import { enclavesMap } from 'modules/enclave/getters.js';
import { submissionEnclaves, company as myCompany } from 'modules/profile/getters.js';

export const enclaveMenuOpen = getterFromKeyPath(['settings', 'enclaveMenuOpen']);
export const timezone = getterFromKeyPath(['settings', 'timezone']);
export const ingestEmails = getterFromKeyPath(['settings', 'ingestEmails']);
export const emailOptions = getterFromKeyPath(['settings', 'emailOptions']);
export const emailLoading = getterFromKeyPath(['settings', 'emailLoading']);
export const currentIngestEmailId = getterFromKeyPath(['settings', 'currentIngestEmailId']);
export const totalEmailCount = getterFromKeyPath(['settings', 'totalEmailCount']);
export const getSelectedIngestEmails = getterFromKeyPath(['settings', 'selectedIngestEmails']);
export const creatingAdditionalInbox = getterFromKeyPath(['settings', 'creatingAdditionalInbox']);
export const showDeleteIngestModal = getterFromKeyPath(['settings', 'showDeleteIngestModal']);
export const showRequestNewInboxModal = getterFromKeyPath(['settings', 'showRequestNewIngestModal']);


export const isCurrentlyEditing = createSelector(
  [currentIngestEmailId],
  (currentlyEditedEmail) => {
    return !!currentlyEditedEmail;
  }
);

export const maxEmailCount = createSelector(
  [myCompany],
  (company) => {
    return company.get('maxIngestEmailsCount');
  },
);

export const currentIngestEmail = createSelector(
  [ingestEmails, currentIngestEmailId],
  (emails, id) => emails.get(id)
);

export const ingestEmailsWithEnclaves = createSelector(
  [ingestEmails, enclavesMap],
  (emails, enclaves) => {
    return emails
      .map(x => x.set('enclave', enclaves.get(x.get('enclaveGuid'))))
      .valueSeq();
  }
);

/* Map user enclaves to array of enclave names for select menu */
export const emailIngestSelectEnclaves = createSelector(
  [submissionEnclaves],
  (enclaves: OrderedMap<string, Map<string, mixed>>): Object[] => {
    return enclaves
      .sort(alphabetizeByKey('name'))
      .map(e => ({
        label: e.get('name'),
        value: e.get('id'),
      }))
      .toIndexedSeq()
      .toArray()
  }
);

export const currentIngestEmailFormValues = createSelector(
  [currentIngestEmail],
  tryCatch(
    pipe(
      x => Map(x.toObject()),
      x => x.update('ingestEmail', x => x.replace(/@.+$/g, '')), // Strip out @ingest.trustar.co
      x => x.update('fromEmails', xs => fromJS(xs).map(from => Map({ from }))),
      x => x.update('subjectPrefixes', xs =>
        fromJS(xs).map(subjectPrefix => Map({ subjectPrefix }))
      )
    ),
    () => null
  )
);

// Initial form value for both updating and creating new email ingests
export const getInitialValues = (): Map<string, mixed> => {
  const defaults = {
    ingestEmail: '',
    fromEmails: [], // Create a single empty field to initialize the FieldArrays
    subjectPrefixes: [], // See NOTE
    enableRedaction: false,
  };

  return fromJS(defaults);
};




// WEBPACK FOOTER //
// ./src/app/modules/settings/getters.js